import { IconProps } from './IconProps';

export const UhxInfoDamage = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.285 7.119C20.2608 7.03593 20.2155 6.96057 20.1534 6.90027C20.0914 6.83997 20.0147 6.79681 19.931 6.775C19.8475 6.75194 19.7593 6.75145 19.6755 6.77359C19.5917 6.79572 19.5153 6.83969 19.454 6.901L16.838 9.458L14.924 9.075L14.543 7.168L17.188 4.583C17.2499 4.52263 17.2951 4.44722 17.3192 4.36415C17.3433 4.28108 17.3454 4.19318 17.3254 4.10905C17.3053 4.02492 17.2638 3.94742 17.2048 3.88414C17.1459 3.82086 17.0715 3.77395 16.989 3.748C16.5081 3.59046 16.006 3.50684 15.5 3.5C12.743 3.5 10.5 5.743 10.5 8.5C10.5 8.823 10.538 9.15 10.618 9.51C10.056 9.973 9.522 10.372 8.917 10.824C8.052 11.47 7.072 12.201 5.735 13.33C5.35077 13.6613 5.04181 14.071 4.82881 14.5315C4.61581 14.992 4.50371 15.4927 4.5 16C4.5 17.93 6.07 19.5 8 19.5C8.50806 19.4986 9.00965 19.386 9.46953 19.17C9.92941 18.9541 10.3364 18.64 10.662 18.25C11.5475 17.2106 12.396 16.1403 13.206 15.041C13.648 14.45 14.038 13.93 14.489 13.381C14.849 13.462 15.177 13.5 15.5 13.5C18.257 13.5 20.5 11.257 20.5 8.5C20.4947 8.03176 20.4223 7.5667 20.285 7.119ZM8 17C7.73478 17 7.48043 16.8946 7.29289 16.7071C7.10536 16.5196 7 16.2652 7 16C7 15.7348 7.10536 15.4804 7.29289 15.2929C7.48043 15.1054 7.73478 15 8 15C8.26522 15 8.51957 15.1054 8.70711 15.2929C8.89464 15.4804 9 15.7348 9 16C9 16.2652 8.89464 16.5196 8.70711 16.7071C8.51957 16.8946 8.26522 17 8 17Z"
        fill="black"
      />
    </svg>
  );
};

